export class UserInfo {

  constructor(public username: string, public tokenExpireDate: number) {
  }

}
